import PropTypes from 'prop-types';
// material
import { Divider, List, ListItemButton, Stack, Tooltip, Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import moment from 'moment';
import { Fragment } from 'react';
import { calculNbG, distanceConverter, speedConverter } from '../../common/utils/unitConverter';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectGeofencesArray, selectSession } from '../../createSelectorUtils';

// utils

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

FlightReviewVol.propTypes = {
  positions: PropTypes.array,
  analyse: PropTypes.object,
  events: PropTypes.array,
  state: PropTypes.object,
  setState: PropTypes.func,
  device: PropTypes.object
};
export default function FlightReviewVol({ analyse, positions, events, state, setState, device }) {
  const t = useTranslation();
  const session = useSelector(selectSession);
  const geofences = useSelector(selectGeofencesArray);

  return (
    <List>
      {analyse.analyseVolReports.map((vol, index) => (
        <Fragment key={index}>
          <ListItemButton
            selected={state.selectedListItem === index}
            onClick={() =>
              setState({
                ...state,
                selectedListItem: index,
                currentPosition: positions.indexOf(
                  positions.find((item) => item.id === vol.startPositionId)
                )
              })
            }
            key={`info-${index}`}
          >
            <Stack direction="column" key={`stackInfo-${index}`}>
              <Typography variant="subtile1">{`n° ${index + 1} - ${moment(
                positions.find((item) => item.id === vol.startPositionId).fixTime
              ).format('HH:mm:ss')}`}</Typography>
              {vol.distance > 0 && (
                <Typography variant="subtitle1">
                  {`Distance: ${distanceConverter(vol.distance / 1000, session.uniteDistance)} ${
                    session.uniteDistance === 'mille' ? 'NM' : session.uniteDistance
                  }`}
                </Typography>
              )}
              <Typography variant="subtitle1">
                {`${t('FR_Details_Duration')} (mm:ss): ${moment(vol.duration).format('mm:ss')}`}
              </Typography>
            </Stack>
          </ListItemButton>
          {vol.speedAlert ? (
            <Tooltip
              title={`${t('FR_Phases_Speed_Vol')}
                ${speedConverter(device.vne, session.uniteVitesse)} ${session.uniteVitesse})`}
              placement="top"
              key={`speedAlert-${index}`}
            >
              <ListItemButton
                selected={state.selectedListItem === index}
                onClick={() =>
                  setState({
                    ...state,
                    selectedListItem: index,
                    currentPosition: positions.indexOf(
                      positions.find((item) => item.id === vol.speedAlert)
                    )
                  })
                }
              >
                <Typography variant="subtitle1" style={{ color: '#bb0b0b' }}>
                  {`Alerte vitesse: ${speedConverter(
                    positions.find((position) => position.id === vol.speedAlert).speed,
                    session.uniteVitesse
                  )} ${session.uniteVitesse}`}
                </Typography>
              </ListItemButton>
            </Tooltip>
          ) : null}
          {vol.gAlert ? (
            <Tooltip
              title={` Vous avez depassé le nombre de G en vol (${device.gVolMinAlert} G)`}
              placement="top"
              key={`g-${index}`}
            >
              <ListItemButton
                selected={state.selectedListItem === index}
                onClick={() =>
                  setState({
                    ...state,
                    selectedListItem: index,
                    currentPosition: positions.indexOf(
                      positions.find((item) => item.id === vol.gAlert)
                    )
                  })
                }
              >
                <Typography variant="subtitle1" style={{ color: '#bb0b0b' }}>
                  {`Alerte G: ${calculNbG(
                    positions.find((position) => position.id === vol.gAlert)
                  )}`}
                </Typography>
              </ListItemButton>
            </Tooltip>
          ) : null}
          {events.map((event) => (
            <Fragment key={event.id}>
              {event.type === 'geofenceEnter' &&
                geofences.map(
                  (geofence) =>
                    event.geofenceId === geofence.id &&
                    positions.indexOf(
                      positions.find((position) => position.id === event.positionId)
                    ) >=
                      positions.indexOf(
                        positions.find((position) => position.id === vol.startPositionId)
                      ) &&
                    positions.indexOf(
                      positions.find((position) => position.id === event.positionId)
                    ) <=
                      positions.indexOf(
                        positions.find((position) => position.id === vol.endPositionId)
                      ) && (
                      <Tooltip
                        title={`Vous avez entrer dans la zone ${geofence.name}`}
                        placement="top"
                        key={`geofence-${index}`}
                      >
                        <ListItemButton
                          selected={state.selectedListItem === index}
                          onClick={() =>
                            setState({
                              ...state,
                              selectedListItem: index,
                              currentPosition: positions.indexOf(
                                positions.find((item) => item.id === event.positionId)
                              )
                            })
                          }
                        >
                          <Typography variant="subtitle1" style={{ color: '#bb0b0b' }}>
                            {`${geofence.name} à ${moment(event.serverTime).format('HH:mm')}`}
                          </Typography>
                        </ListItemButton>
                      </Tooltip>
                    )
                )}
            </Fragment>
          ))}
          <Divider />
        </Fragment>
      ))}
    </List>
  );
}
